import React from 'react';

const UserProfileIcon = () => {
  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 8C9.39397 8 9.78407 7.9224 10.1481 7.77164C10.512 7.62087 10.8427 7.3999 11.1213 7.12132C11.3999 6.84274 11.6209 6.51203 11.7716 6.14805C11.9224 5.78407 12 5.39397 12 5C12 4.60603 11.9224 4.21593 11.7716 3.85195C11.6209 3.48797 11.3999 3.15726 11.1213 2.87868C10.8427 2.6001 10.512 2.37913 10.1481 2.22836C9.78407 2.0776 9.39397 2 9 2C8.20435 2 7.44129 2.31607 6.87868 2.87868C6.31607 3.44129 6 4.20435 6 5C6 5.79565 6.31607 6.55871 6.87868 7.12132C7.44129 7.68393 8.20435 8 9 8ZM9 10C10.3261 10 11.5979 9.47322 12.5355 8.53553C13.4732 7.59785 14 6.32608 14 5C14 3.67392 13.4732 2.40215 12.5355 1.46447C11.5979 0.526784 10.3261 0 9 0C7.67392 0 6.40215 0.526784 5.46447 1.46447C4.52678 2.40215 4 3.67392 4 5C4 6.32608 4.52678 7.59785 5.46447 8.53553C6.40215 9.47322 7.67392 10 9 10ZM1.639 13.448C2.784 11.93 4.509 11 6.714 11H11.286C13.491 11 15.216 11.93 16.361 13.448C17.482 14.935 18 16.916 18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20C16.7348 20 16.4804 19.8946 16.2929 19.7071C16.1054 19.5196 16 19.2652 16 19C16 17.218 15.554 15.7 14.765 14.652C14 13.638 12.867 13 11.285 13H6.715C5.133 13 4 13.638 3.235 14.652C2.445 15.7 2 17.218 2 19C2 19.2652 1.89464 19.5196 1.70711 19.7071C1.51957 19.8946 1.26522 20 1 20C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19C0 16.916 0.518 14.935 1.639 13.448Z'
        fill='#6B7280'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 19C0 18.7348 0.105357 18.4804 0.292893 18.2929C0.48043 18.1054 0.734784 18 1 18H16.962C17.2272 18 17.4816 18.1054 17.6691 18.2929C17.8566 18.4804 17.962 18.7348 17.962 19C17.962 19.2652 17.8566 19.5196 17.6691 19.7071C17.4816 19.8946 17.2272 20 16.962 20H1C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19Z'
        fill='#6B7280'
      />
    </svg>
  );
};

export default UserProfileIcon;
